import { BaseOptionType } from 'antd/es/select'

export const relationshipValues = [
  {
    "Code": "BP",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Billing contact person",
    "Definition": ""
  },
  {
    "Code": "C",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Emergency Contact",
    "Definition": ""
  },
  {
    "Code": "CP",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Contact person",
    "Definition": ""
  },
  {
    "Code": "E",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Employer",
    "Definition": ""
  },
  {
    "Code": "EP",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Emergency contact person",
    "Definition": ""
  },
  {
    "Code": "F",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Federal Agency",
    "Definition": ""
  },
  {
    "Code": "I",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Insurance Company",
    "Definition": ""
  },
  {
    "Code": "N",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Next-of-Kin",
    "Definition": ""
  },
  {
    "Code": "O",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Other",
    "Definition": ""
  },
  {
    "Code": "PR",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Person preparing referral",
    "Definition": ""
  },
  {
    "Code": "S",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "State Agency",
    "Definition": ""
  },
  {
    "Code": "U",
    "System": "http://hl7.org/fhir/v2/0131",
    "Display": "Unknown",
    "Definition": ""
  },
  {
    "Code": "FAMMEMB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Family member",
    "Definition": "A relationship between two people characterizing their \"familial\" relationship"
  },
  {
    "Code": "CHILD",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Child",
    "Definition": "The player of the role is a child of the scoping entity."
  },
  {
    "Code": "CHLDADOPT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adopted child",
    "Definition": "The player of the role is a child taken into a family through legal means and raised by the scoping person (parent) as his or her own child."
  },
  {
    "Code": "DAUADOPT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adopted daughter",
    "Definition": "The player of the role is a female child taken into a family through legal means and raised by the scoping person (parent) as his or her own child."
  },
  {
    "Code": "SONADOPT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adopted son",
    "Definition": "The player of the role is a male child taken into a family through legal means and raised by the scoping person (parent) as his or her own child."
  },
  {
    "Code": "CHLDFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster child",
    "Definition": "The player of the role is a child receiving parental care and nurture from the scoping person (parent) but not related to him or her through legal or blood ties."
  },
  {
    "Code": "DAUFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster daughter",
    "Definition": "The player of the role is a female child receiving parental care and nurture from the scoping person (parent) but not related to him or her through legal or blood ties."
  },
  {
    "Code": "SONFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster son",
    "Definition": "The player of the role is a male child receiving parental care and nurture from the scoping person (parent) but not related to him or her through legal or blood ties."
  },
  {
    "Code": "DAUC",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Daughter",
    "Definition": "Description: The player of the role is a female child (of any type) of scoping entity (parent)"
  },
  {
    "Code": "DAU",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural daughter",
    "Definition": "The player of the role is a female offspring of the scoping entity (parent)."
  },
  {
    "Code": "STPDAU",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepdaughter",
    "Definition": "The player of the role is a daughter of the scoping person's spouse by a previous union."
  },
  {
    "Code": "NCHILD",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural child",
    "Definition": "The player of the role is an offspring of the scoping entity as determined by birth."
  },
  {
    "Code": "SON",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural son",
    "Definition": "The player of the role is a male offspring of the scoping entity (parent)."
  },
  {
    "Code": "SONC",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Son",
    "Definition": "Description: The player of the role is a male child (of any type) of scoping entity (parent)"
  },
  {
    "Code": "STPSON",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepson",
    "Definition": "The player of the role is a son of the scoping person's spouse by a previous union."
  },
  {
    "Code": "STPCHLD",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Step child",
    "Definition": "The player of the role is a child of the scoping person's spouse by a previous union."
  },
  {
    "Code": "EXT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Extended family member",
    "Definition": "Description: A family member not having an immediate genetic or legal relationship e.g. Aunt, cousin, great grandparent, grandchild, grandparent, niece, nephew or uncle."
  },
  {
    "Code": "AUNT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Aunt",
    "Definition": "The player of the role is a sister of the scoping person's mother or father."
  },
  {
    "Code": "MAUNT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal aunt",
    "Definition": "Description:The player of the role is a biological sister of the scoping person's biological mother."
  },
  {
    "Code": "PAUNT",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal aunt",
    "Definition": "Description:The player of the role is a biological sister of the scoping person's biological father."
  },
  {
    "Code": "COUSN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Cousin",
    "Definition": "The player of the role is a relative of the scoping person descended from a common ancestor, such as a \tgrandparent, by two or more steps in a diverging line."
  },
  {
    "Code": "MCOUSN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal cousin",
    "Definition": "Description:The player of the role is a biological relative of the scoping person descended from a common ancestor on the player's mother's side, such as a grandparent, by two or more steps in a diverging line."
  },
  {
    "Code": "PCOUSN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal cousin",
    "Definition": "Description:The player of the role is a biological relative of the scoping person descended from a common ancestor on the player's father's side, such as a grandparent, by two or more steps in a diverging line."
  },
  {
    "Code": "GGRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Great grandparent",
    "Definition": "The player of the role is a parent of the scoping person's grandparent."
  },
  {
    "Code": "GGRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Great grandfather",
    "Definition": "The player of the role is the father of the scoping person's grandparent."
  },
  {
    "Code": "MGGRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal great-grandfather",
    "Definition": "Description:The player of the role is the biological father of the scoping person's biological mother's parent."
  },
  {
    "Code": "PGGRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal great-grandfather",
    "Definition": "Description:The player of the role is the biological father of the scoping person's biological father's parent."
  },
  {
    "Code": "GGRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Great grandmother",
    "Definition": "The player of the role is the mother of the scoping person's grandparent."
  },
  {
    "Code": "MGGRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal great-grandmother",
    "Definition": "Description:The player of the role is the biological mother of the scoping person's biological mother's parent."
  },
  {
    "Code": "PGGRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal great-grandmother",
    "Definition": "Description:The player of the role is the biological mother of the scoping person's biological father's parent."
  },
  {
    "Code": "MGGRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal great-grandparent",
    "Definition": "Description:The player of the role is a biological parent of the scoping person's biological mother's parent."
  },
  {
    "Code": "PGGRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal great-grandparent",
    "Definition": "Description:The player of the role is a biological parent of the scoping person's biological father's parent."
  },
  {
    "Code": "GRNDCHILD",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Grandchild",
    "Definition": "The player of the role is a child of the scoping person's son or daughter."
  },
  {
    "Code": "GRNDDAU",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Granddaughter",
    "Definition": "The player of the role is a daughter of the scoping person's son or daughter."
  },
  {
    "Code": "GRNDSON",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Grandson",
    "Definition": "The player of the role is a son of the scoping person's son or daughter."
  },
  {
    "Code": "GRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Grandparent",
    "Definition": "The player of the role is a parent of the scoping person's mother or father."
  },
  {
    "Code": "GRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Grandfather",
    "Definition": "The player of the role is the father of the scoping person's mother or father."
  },
  {
    "Code": "MGRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal grandfather",
    "Definition": "Description:The player of the role is the biological father of the scoping person's biological mother."
  },
  {
    "Code": "PGRFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal grandfather",
    "Definition": "Description:The player of the role is the biological father of the scoping person's biological father."
  },
  {
    "Code": "GRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Grandmother",
    "Definition": "The player of the role is the mother of the scoping person's mother or father."
  },
  {
    "Code": "MGRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal grandmother",
    "Definition": "Description:The player of the role is the biological mother of the scoping person's biological mother."
  },
  {
    "Code": "PGRMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal grandmother",
    "Definition": "Description:The player of the role is the biological mother of the scoping person's biological father."
  },
  {
    "Code": "MGRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal grandparent",
    "Definition": "Description:The player of the role is the biological parent of the scoping person's biological mother."
  },
  {
    "Code": "PGRPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal grandparent",
    "Definition": "Description:The player of the role is the biological parent of the scoping person's biological father."
  },
  {
    "Code": "INLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Inlaw",
    "Definition": "A relationship between an individual and a member of their spousal partner's immediate family."
  },
  {
    "Code": "CHLDINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Child-in-law",
    "Definition": "The player of the role is the spouse of scoping person's child."
  },
  {
    "Code": "DAUINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Daughter in-law",
    "Definition": "The player of the role is the wife of scoping person's son."
  },
  {
    "Code": "SONINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Son in-law",
    "Definition": "The player of the role is the husband of scoping person's daughter."
  },
  {
    "Code": "PRNINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Parent in-law",
    "Definition": "The player of the role is the parent of scoping person's husband or wife."
  },
  {
    "Code": "FTHINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Father-in-law",
    "Definition": "The player of the role is the father of the scoping person's husband or wife."
  },
  {
    "Code": "MTHINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Mother-in-law",
    "Definition": "The player of the role is the mother of the scoping person's husband or wife."
  },
  {
    "Code": "SIBINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Sibling in-law",
    "Definition": "The player of the role is: (1) a sibling of the scoping person's spouse, or (2) the spouse of the scoping person's sibling, or (3) the spouse of a sibling of the scoping person's spouse."
  },
  {
    "Code": "BROINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Brother-in-law",
    "Definition": "The player of the role is: (1) a brother of the scoping person's spouse, or (2) the husband of the scoping person's sister, or (3) the husband of a sister of the scoping person's spouse."
  },
  {
    "Code": "SISINLAW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Sister-in-law",
    "Definition": "The player of the role is: (1) a sister of the scoping person's spouse, or (2) the wife of the scoping person's brother, or (3) the wife of a brother of the scoping person's spouse."
  },
  {
    "Code": "NIENEPH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Niece/nephew",
    "Definition": "The player of the role is a child of scoping person's brother or sister or of the brother or sister of the \tscoping person's spouse."
  },
  {
    "Code": "NEPHEW",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Nephew",
    "Definition": "The player of the role is a son of the scoping person's brother or sister or of the brother or sister of the \tscoping person's spouse."
  },
  {
    "Code": "NIECE",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Niece",
    "Definition": "The player of the role is a daughter of the scoping person's brother or sister or of the brother or sister of the \tscoping person's spouse."
  },
  {
    "Code": "UNCLE",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Uncle",
    "Definition": "The player of the role is a brother of the scoping person's mother or father."
  },
  {
    "Code": "MUNCLE",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Maternal uncle",
    "Definition": "Description:The player of the role is a biological brother of the scoping person's biological mother."
  },
  {
    "Code": "PUNCLE",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Paternal uncle",
    "Definition": "Description:The player of the role is a biological brother of the scoping person's biological father."
  },
  {
    "Code": "PRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Parent",
    "Definition": "The player of the role is one who begets, gives birth to, or nurtures and raises the scoping entity (child)."
  },
  {
    "Code": "ADOPTP",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adoptive parent",
    "Definition": "The player of the role (parent) has taken the scoper (child) into their family through legal means and raises them as his or her own child."
  },
  {
    "Code": "ADOPTF",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adoptive father",
    "Definition": "The player of the role (father) is a male who has taken the scoper (child) into their family through legal means and raises them as his own child."
  },
  {
    "Code": "ADOPTM",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Adoptive mother",
    "Definition": "The player of the role (father) is a female who has taken the scoper (child) into their family through legal means and raises them as her own child."
  },
  {
    "Code": "FTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Father",
    "Definition": "The player of the role is a male who begets or raises or nurtures the scoping entity (child)."
  },
  {
    "Code": "FTHFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster father",
    "Definition": "The player of the role (parent) who is a male state-certified caregiver responsible for the scoper (child) who has been placed in the parent's care. The placement of the child is usually arranged through the government or a social-service agency, and temporary. The state, via a jurisdiction recognized child protection agency, stands as in loco parentis to the child, making all legal decisions while the foster parent is responsible for the day-to-day care of the specified child."
  },
  {
    "Code": "NFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural father",
    "Definition": "The player of the role is a male who begets the scoping entity (child)."
  },
  {
    "Code": "NFTHF",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural father of fetus",
    "Definition": "Indicates the biologic male parent of a fetus."
  },
  {
    "Code": "STPFTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepfather",
    "Definition": "The player of the role is the husband of scoping person's mother and not the scoping person's natural father."
  },
  {
    "Code": "MTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Mother",
    "Definition": "The player of the role is a female who conceives, gives birth to, or raises and nurtures the scoping entity (child)."
  },
  {
    "Code": "GESTM",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Gestational mother",
    "Definition": "The player is a female whose womb carries the fetus of the scoper. Generally used when the gestational mother and natural mother are not the same."
  },
  {
    "Code": "MTHFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster mother",
    "Definition": "The player of the role (parent) who is a female state-certified caregiver responsible for the scoper (child) who has been placed in the parent's care. The placement of the child is usually arranged through the government or a social-service agency, and temporary. The state, via a jurisdiction recognized child protection agency, stands as in loco parentis to the child, making all legal decisions while the foster parent is responsible for the day-to-day care of the specified child."
  },
  {
    "Code": "NMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural mother",
    "Definition": "The player of the role is a female who conceives or gives birth to the scoping entity (child)."
  },
  {
    "Code": "NMTHF",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural mother of fetus",
    "Definition": "The player is the biologic female parent of the scoping fetus."
  },
  {
    "Code": "STPMTH",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepmother",
    "Definition": "The player of the role is the wife of scoping person's father and not the scoping person's natural mother."
  },
  {
    "Code": "NPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural parent",
    "Definition": "natural parent"
  },
  {
    "Code": "PRNFOST",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Foster parent",
    "Definition": "The player of the role (parent) who is a state-certified caregiver responsible for the scoper (child) who has been placed in the parent's care. The placement of the child is usually arranged through the government or a social-service agency, and temporary. The state, via a jurisdiction recognized child protection agency, stands as in loco parentis to the child, making all legal decisions while the foster parent is responsible for the day-to-day care of the specified child."
  },
  {
    "Code": "STPPRN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Step parent",
    "Definition": "The player of the role is the spouse of the scoping person's parent and not the scoping person's natural parent."
  },
  {
    "Code": "SIB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Sibling",
    "Definition": "The player of the role shares one or both parents in common with the scoping entity."
  },
  {
    "Code": "BRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Brother",
    "Definition": "The player of the role is a male sharing one or both parents in common with the scoping entity."
  },
  {
    "Code": "HBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Half-brother",
    "Definition": "The player of the role is a male related to the scoping entity by sharing only one biological parent."
  },
  {
    "Code": "NBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural brother",
    "Definition": "The player of the role is a male having the same biological parents as the scoping entity."
  },
  {
    "Code": "TWINBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Twin brother",
    "Definition": "The scoper was carried in the same womb as the male player and shares common biological parents."
  },
  {
    "Code": "FTWINBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Fraternal twin brother",
    "Definition": "The scoper was carried in the same womb as the male player and shares common biological parents but is the product of a distinct egg/sperm pair."
  },
  {
    "Code": "ITWINBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Identical twin brother",
    "Definition": "The male scoper is an offspring of the same egg-sperm pair as the male player."
  },
  {
    "Code": "STPBRO",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepbrother",
    "Definition": "The player of the role is a son of the scoping person's stepparent."
  },
  {
    "Code": "HSIB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Half-sibling",
    "Definition": "The player of the role is related to the scoping entity by sharing only one biological parent."
  },
  {
    "Code": "HSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Half-sister",
    "Definition": "The player of the role is a female related to the scoping entity by sharing only one biological parent."
  },
  {
    "Code": "NSIB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural sibling",
    "Definition": "The player of the role has both biological parents in common with the scoping entity."
  },
  {
    "Code": "NSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Natural sister",
    "Definition": "The player of the role is a female having the same biological parents as the scoping entity."
  },
  {
    "Code": "TWINSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Twin sister",
    "Definition": "The scoper was carried in the same womb as the female player and shares common biological parents."
  },
  {
    "Code": "FTWINSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Fraternal twin sister",
    "Definition": "The scoper was carried in the same womb as the female player and shares common biological parents but is the product of a distinct egg/sperm pair."
  },
  {
    "Code": "ITWINSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Identical twin sister",
    "Definition": "The female scoper is an offspring of the same egg-sperm pair as the female player."
  },
  {
    "Code": "TWIN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Twin",
    "Definition": "The scoper and player were carried in the same womb and shared common biological parents."
  },
  {
    "Code": "FTWIN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Fraternal twin",
    "Definition": "The scoper and player were carried in the same womb and share common biological parents but are the product of distinct egg/sperm pairs."
  },
  {
    "Code": "ITWIN",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Identical twin",
    "Definition": "The scoper and player are offspring of the same egg-sperm pair."
  },
  {
    "Code": "SIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Sister",
    "Definition": "The player of the role is a female sharing one or both parents in common with the scoping entity."
  },
  {
    "Code": "STPSIS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Stepsister",
    "Definition": "The player of the role is a daughter of the scoping person's stepparent."
  },
  {
    "Code": "STPSIB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Step sibling",
    "Definition": "The player of the role is a child of the scoping person's stepparent."
  },
  {
    "Code": "SIGOTHR",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Significant other",
    "Definition": "A person who is important to one's well being; especially a spouse or one in a similar relationship. (The player is the one who is important)"
  },
  {
    "Code": "DOMPART",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Domestic partner",
    "Definition": "The player of the role cohabits with the scoping person but is not the scoping person's spouse."
  },
  {
    "Code": "FMRSPS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Former spouse",
    "Definition": "Player of the role was previously joined to the scoping person in marriage and this marriage is now dissolved and inactive. Usage Note: This is significant to indicate as some jurisdictions have different legal requirements for former spouse to access the patient's record, from a general friend."
  },
  {
    "Code": "SPS",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Spouse",
    "Definition": "The player of the role is a marriage partner of the scoping person."
  },
  {
    "Code": "HUSB",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Husband",
    "Definition": "The player of the role is a man joined to a woman (scoping person) in marriage."
  },
  {
    "Code": "WIFE",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Wife",
    "Definition": "The player of the role is a woman joined to a man (scoping person) in marriage."
  },
  {
    "Code": "FRND",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Unrelated friend",
    "Definition": "The player of the role is a person who is known, liked, and trusted by the scoping person."
  },
  {
    "Code": "NBOR",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Neighbor",
    "Definition": "The player of the role lives near or next to the \tscoping person."
  },
  {
    "Code": "ONESELF",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Self",
    "Definition": "The relationship that a person has with his or her self."
  },
  {
    "Code": "ROOM",
    "System": "http://hl7.org/fhir/v3/RoleCode",
    "Display": "Roommate",
    "Definition": "One who shares living quarters with the subject."
  }
]

export const relationshipOptions: BaseOptionType[] = relationshipValues.map(
  (value) => ({
    label: value.Display,
    value: value.Code,
  })
)